import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import * as Const from "../constants/LiveMonitoringConstants";
import { addFilter, getFilterValue } from "../../../utils/FilterUtils";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { STATE_ACTIVE_FILTERS } from "../constants/LiveMonitoringConfigurationRecoil";
import AdvancedFilter from "../../../component/AdvancedFilter";
import * as Renders from "../../../component/AdvancedFiltersRenders";
import { useNavigate } from "react-router-dom";
import { offsetDateJsConvert, reverseConvertDate } from "../util/CashbackUtil";

function EmptyLiveMonitoringFilter() {
    const { t } = useTranslation("finance", { keyPrefix: "cashback" });

    const setFilters = useSetRecoilState(STATE_ACTIVE_FILTERS);
    const filterDefs = useRecoilValue(STATE_ACTIVE_FILTERS);
    //if (setFilters.length > 0) setFilters([]);

    const navigate = useNavigate();
    const schema = Yup.object().shape({
        [Const.ID_FILTER_DATE_FROM_LM]: Yup.date().nullable().required(t('filters.errors.required-date')).test("testFrom", t('filters.errors.invalid-date-to'), (value, context) => {
            return !value || !context.parent.datTo || (value <= context.parent.dateFrom);
        }).test('date-range', t('filters.errors.invalid-date-from'), function (value) {
            const { dateTo } = this.parent;
            return !value || !dateTo || value <= dateTo;
        }).typeError(t('filters.errors.invalid-date-to')),
        [Const.ID_FILTER_DATE_TO_LM]: Yup.date().nullable().required(t('filters.errors.required-date')).test("testTo", t('filters.errors.invalid-date-to'), (value, context) => {
            return !value || !context.parent.dateTo || (value >= context.parent.dateFrom);
        }).test('date-range', t('filters.errors.invalid-date-from'), function (value) {
            const { dateFrom } = this.parent;
            return !value || !dateFrom || value >= dateFrom;
        }).typeError(t('filters.errors.invalid-date-to')),
    });
    const defaultValues = {
        [Const.ID_FILTER_DATE_FROM_LM]: getFilterValue(Const.ID_FILTER_DATE_FROM_LM, filterDefs) || null,
        [Const.ID_FILTER_DATE_TO_LM]: getFilterValue(Const.ID_FILTER_DATE_TO_LM, filterDefs) || null
    };

    const customDefaultValues = {
        [Const.ID_FILTER_DATE_FROM_LM]: null,
        [Const.ID_FILTER_DATE_TO_LM]: null
    };

    const fields = {
        main: {
            dateFrom: Renders.renderDatePickerFrom(
                "dateFrom",
                t("livemonitoring.filters." + Const.ID_FILTER_DATE_FROM_LM)
            ),
            dateTo: Renders.rendereDatePickerTo(
                "dateTo",
                t("livemonitoring.filters." + Const.ID_FILTER_DATE_TO_LM)
            ),
        },
        adv: {

        }
    };

    const submit = (data: any) => {
        Object.keys(defaultValues)
            .forEach((param) => {
                addFilter(setFilters, param, offsetDateJsConvert(reverseConvertDate(data[param]), 'DD/MM/YYYY'));
            });

        navigate(`/finance/cashback?dateFrom=${reverseConvertDate(data.dateFrom)}&dateTo=${reverseConvertDate(data.dateTo)}`);
    };

    const reset = () => {
        setFilters([]);
    };

    return (
        <AdvancedFilter
            schema={schema}
            mainFields={fields.main}
            fields={fields.adv}
            defaultValues={defaultValues}
            onSubmit={submit}
            onReset={reset}
            customDefaultValues={customDefaultValues}
        />
    );
}

export default EmptyLiveMonitoringFilter;
